import notify from "devextreme/ui/notify";
import React, { useRef, useState } from "react"
import { useSelector } from "react-redux";
import { DataGrid, Modal } from "../../components"
import { DataGridButtonProps, GridButtonType } from "../../components/data-grid/types";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { adminBlogsUrl } from "../../services/urls"
import CreateBlogform from "./create";
import BlogDetail from "./detail";
import EditBlogform from "./edit";
import { CreateBlog, UpdateBlog } from "./type";


const BlogPage = () => {
    const [show, setShow] = useState(false)
    const [show1, setShow1] = useState(false)
    const localize = useSelector(getLocalized);
    const { token, lang } = useSelector(getApiParams);
    const ref = useRef<any>();
    const ref1 = useRef<any>()
    const [, setBData] = useState<any>([])
    const updateData = useRef<UpdateBlog>({
        Id: "",
        BlogTags: [],
        Content: "",
        Image: "",
        Name: "",
        ProductCategoryId: "",
        ShortContent: ""
    })
    const columns = [
        {
            dataField: "Name",
            caption: localize.getString("name")
        },
        {
            dataField: "ProductCategoryName",
            caption: localize.getString("category")
        }

    ]
    const data = useRef<CreateBlog>({
        BlogTags: [""],
        Content: "",
        Image: "",
        Name: "",
        ProductCategoryId: "",
        ShortContent: ""
    })
    const buttons: GridButtonType[] = [
        {
            buttonText: "Yeni",
            icon: "add",
            type: "success",
            onclick: () => {
                setShow(true)
            }
        }
    ]
    const buttons1: DataGridButtonProps[] = [
        {
            hint: "edit",
            icon: "edit",
            onClick: (e: any) => {
                setBData(e.row.data.BlogTags.map((item: any) => item.Name))
                updateData.current.Content = e.row.data.Content
                updateData.current.Name = e.row.data.Name
                updateData.current.ProductCategoryId = e.row.data.ProductCategoryId
                updateData.current.ShortContent = e.row.data.ShortContent
                updateData.current.Id = e.row.data.Id
                updateData.current.Image = e.row.data.Image
                updateData.current.BlogTags = (e.row.data.BlogTags.map((item: any) => item.Name))
                setShow1(true)
            },
        },
    ];
    return <>
        <Modal
            visible={show}
            onHiding={() => { setShow(false) }}
            title={localize.getString("createBlog")}
            width="60%"
            height="95%"
            onSubmitClick={async () => {
                console.log(data.current)

                const response: ApiResponse<CreateBlog> = await createRequest({
                    method: "POST",
                    url: adminBlogsUrl,
                    bodyType: BodyType.formdata,
                    token,
                    body: data.current,
                    lang,
                });
                if (verfiyResponse(response)) {
                    notify(response.Message, "success")
                    setShow(false)

                    ref.current.instance.resetValues();
                    setShow(false)
                } else {
                    notify(response.Message, "warning")
                }

            }}>
            <CreateBlogform data={data.current} ref={ref} ></CreateBlogform>
        </Modal>
        <Modal
            visible={show1}
            onHiding={() => { setShow1(false) }}
            title={localize.getString("editBlog")}
            width="60%"
            height="90%"
            onSubmitClick={async () => {
                const response: ApiResponse<UpdateBlog> = await createRequest({
                    method: "PUT",
                    url: adminBlogsUrl + "/" + updateData.current.Id,
                    bodyType: BodyType.formdata,
                    token,
                    body: updateData.current,
                    lang,
                });
                if (verfiyResponse(response)) {
                    notify(response.Message, "success")

                    setShow1(false)
                    ref1.current.instance.resetValues()
                } else {
                    notify(response.Message, "warning")
                }

            }}>
            <EditBlogform data={updateData.current} ref={ref1} ></EditBlogform>
        </Modal>
        <DataGrid

            url={adminBlogsUrl}
            getByIdUrl={adminBlogsUrl}
            columns={columns}
            buttons={buttons1}
            refObject={{}}
            title={localize.getString("blog")}
            gridButtons={buttons}
            details={{
                width: "70%",
                height: "95%",
                getByIdUrl: adminBlogsUrl,
                title: localize.getString("blogDetail"),
                component: BlogDetail,
            }}
            remove={{
                url: adminBlogsUrl
            }}
        />
    </>


}

export default BlogPage